import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=b98f5410&scoped=true"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=b98f5410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98f5410",
  null
  
)

export default component.exports